import paths from '@paths';
import {SignInRoutes, SignUpRoutes, ResetPasswordRoutes} from '../Routes';
import common from './common';

const routing: AppRoute[] = [
  {path: paths.signIn.main, exact: true, component: SignInRoutes},
  {path: paths.signUp.main, exact: true, component: SignUpRoutes},
  {path: paths.signUp.confirm, exact: true, component: SignUpRoutes},
  {path: paths.signUp.thank, exact: true, component: SignUpRoutes},
  {path: paths.signUp.resendConfirm, exact: true, component: SignUpRoutes},

  {
    path: paths.resetPassword.main,
    exact: true,
    component: ResetPasswordRoutes,
  },
  {
    path: paths.resetPassword.confirm,
    exact: true,
    component: ResetPasswordRoutes,
  },
  {
    path: paths.resetPassword.thank,
    exact: true,
    component: ResetPasswordRoutes,
  },
  ...common,
];

export default routing;
